// Helper to get the frontend URL dynamically
function getFrontendUrl() {
  // In production/deployed environments, use the actual origin
  if (typeof window !== 'undefined' && window.location.origin && 
      !window.location.origin.includes('localhost') && 
      !window.location.origin.includes('127.0.0.1')) {
    return window.location.origin;
  }
  // Development fallback (dev-full stack: frontend is served via Envoy on :8080)
  return 'http://localhost:8080';
}

const config = {
  // All values loaded from hub-fe-config.json at runtime
  bffUrl: null,
  agentUrl: null,
  publicBaseUrl: null,
  apiKeyBff: null,
  apiKeyBe: null,
  consoleBaseUrl: null, // Mia Platform Console base URL
  aiFoundryBaseUrl: null, // AI Foundry application base URL
  get frontendUrl() {
    return getFrontendUrl();
  }, // Frontend application URL - MUST match Okta redirect URI configuration
  
  // Mia Platform project configuration (default / Web App mode).
  // No serviceTemplate* here: the default template (Mia Flow React Template)
  // is resolved dynamically by the BFF at request time, not pinned per environment.
  defaultAppServiceRevisionId: 'main',

  // Per-template configs for Full Stack mode
  // Keys map to the template name selected in the UI
  fullStackTemplateConfigs: {
    'React + Node.js Application': {
      templateItemId: null,
      templateTenantId: null,
      templateVersion: null,
      templateId: null,
    },
    'React + .NET Core Application': {
      templateItemId: null,
      templateTenantId: null,
      templateVersion: null,
      templateId: null,
    },
    'React + Java Application': {
      templateItemId: null,
      templateTenantId: null,
      templateVersion: null,
      templateId: null,
    },
    'Only Backend Java': {
      templateItemId: null,
      templateTenantId: null,
      templateVersion: null,
      templateId: null,
    },
    'Only Backend .NET': {
      templateItemId: null,
      templateTenantId: null,
      templateVersion: null,
      templateId: null,
    },
    'Only Backend Node.js': {
      templateItemId: null,
      templateTenantId: null,
      templateVersion: null,
      templateId: null,
    },
    'Next.js Application': {
      templateItemId: null,
      templateTenantId: null,
      templateVersion: null,
      templateId: null,
    },
  },
  
  // Token management configuration
  tokenLimits: {
    maxTokens: 1000000,           // Maximum tokens before forcing conversation restart (32K for most models)
    compressionThreshold: 0.5,  // Compress conversation at 50% of maxTokens (16K tokens)
    warningThreshold: 0.8,      // Show warning at 80% of maxTokens (25.6K tokens)
  },
  
};

export default config;

let hubConfig = {};

export async function loadHubConfig() {
    try {
      // hub-fe-config.json lives in the FE's public dir, which Vite serves under
      // the app's base path (import.meta.env.BASE_URL, e.g. '/flow/'). Fetching the
      // origin-root '/hub-fe-config.json' would miss it: Envoy 301-redirects any
      // non-matching path to '/flow/', so the fetch would silently receive the HTML
      // index instead of JSON, leaving config.bffUrl null and breaking every API call.
      const baseUrl = import.meta.env.BASE_URL || '/';
      const configUrl = `${baseUrl.replace(/\/$/, '')}/hub-fe-config.json`;
      const res = await fetch(configUrl);
      if (!res.ok) {
        // eslint-disable-next-line no-console
        console.warn('Failed to load hub-fe-config.json, using default config');
        return;
      }
      hubConfig = await res.json();
      
      // Override config with runtime values from hub-fe-config.json
      config.bffUrl = hubConfig.bffUrl;
      config.agentUrl = hubConfig.agentUrl;
      config.publicBaseUrl = hubConfig.publicBaseUrl;
      config.apiKeyBff = hubConfig.apiKeyBff;
      config.apiKeyBe = hubConfig.apiKeyBe;
      config.consoleBaseUrl = hubConfig.consoleBaseUrl || config.consoleBaseUrl;
      config.aiFoundryBaseUrl = hubConfig.aiFoundryBaseUrl || config.aiFoundryBaseUrl;

      config.defaultAppServiceRevisionId = hubConfig.defaultAppServiceRevisionId;

      // Per-template configs for Full Stack mode
      const templateKeyMap = {
        'React + Node.js Application':  'reactNode',
        'React + .NET Core Application': 'reactDotnet',
        'React + Java Application':     'reactJava',
        'Only Backend Java':            'backendJava',
        'Only Backend .NET':            'backendDotnet',
        'Only Backend Node.js':         'backendNode',
        'Next.js Application':          'nextjs',
      };
      Object.entries(templateKeyMap).forEach(([templateName, key]) => {
        config.fullStackTemplateConfigs[templateName] = {
          templateItemId:   hubConfig[`${key}TemplateItemId`]   || null,
          templateTenantId: hubConfig[`${key}TemplateTenantId`] || null,
          templateVersion:  hubConfig[`${key}TemplateVersion`]  || null,
          templateId:       hubConfig[`${key}TemplateId`]       || null,
        };
      });

      // eslint-disable-next-line no-console
      console.log('Loaded runtime config:', {bffUrl: config.bffUrl, agentUrl: config.agentUrl});
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Error loading hub-fe-config.json:', error);
    }
}
  
export function getHubConfig() {
    return hubConfig;
}

// Check if the configuration has been loaded
export function isConfigLoaded() {
  return !!(config.bffUrl && config.agentUrl);
}

